import { createSelector } from "reselect";

const warehouseInventoriesState = (state) => state.warehouseInventories;

export const selectLoading = createSelector(warehouseInventoriesState, (inventories) => inventories.loading);
export const selectError = createSelector(warehouseInventoriesState, (inventories) => inventories.error);
export const selectAllWarehouseInventories = createSelector(warehouseInventoriesState, (inventories) => inventories.all.items);
export const selectAllIncluded = createSelector(warehouseInventoriesState, (inventories) => inventories.all.included);
export const selectWarehouses = createSelector(warehouseInventoriesState, (inventories) => inventories.warehouses);
